module.exports = __webpack_public_path__ + "static/img/ARAD2S_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD2S_2.png
// module id = 5hDC
// module chunks = 0